import {
  IStepProgressBar,
  IStepProgressBarData,
} from "@/components/StepProgressBar/types";
import {
  Status,
  StatusBox,
  StepBar,
  Text,
} from "@/components/StepProgressBar/styled";
import { Fragment } from "react";
import { useRouter } from "next/router";
import { isWebViewClient } from "@/utils/omniture";
import { isBrowser } from "@/utils/general";

const StepProgressBar = ({ active, data }: IStepProgressBar) => {
  const activeNo = Number(active - 1);
  const router = useRouter();

  return (
    <StepBar active={active}>
      {data.map((item, index, array) => {
        const lastItem = index === array.length - 1;
        const firstItem = index === 0;
        const { name } = item;
        const { path } = item;
        const notActive = index > activeNo;
        const completed = index < activeNo;

        return (
          <Fragment key={index}>
            <StatusBox
              onClick={() =>
                index == 0
                  ? !isWebViewClient() &&
                  (window.location.href = `${process.env.NEXT_PUBLIC_BASE_PATH}`) // sayfanın baştan reload olması gerektiği için otp adımında router push kullanmadık
                  : completed && activeNo && router.push(`${path}`)
              }
              activeNo={index === activeNo}
              completed={completed}
            >
              <div className="input-box">
                {!firstItem && <div className="border-left"></div>}
                {index != activeNo ? (
                  <Status notActive={notActive} completed={completed}></Status>
                ) : (
                  <input
                    type="radio"
                    id="input"
                    name="input"
                    checked
                    readOnly
                  />
                )}

                {!lastItem && <div className="border-right"></div>}
              </div>
              <Text
                notActive={index > activeNo}
                activeNo={index === activeNo}
                completed={completed}
              >
                {name}
              </Text>
            </StatusBox>
          </Fragment>
        );
      })}
    </StepBar>
  );
};
export default StepProgressBar;
